<script>
	import {onMount} from 'svelte'
	import { execQuery, execRawMutation, execMutation, execMercadoPago } from '../csql.js'
	import { usuario } from '../store.js'

	export let cartid = 0
	export let cart_handler = () => alert("Unhandled action.CartView")
	export let expand = 'h'

	let provincias = []
	let loading = false
	let ready = false

	let openMsg1 = false
	let openMsg2 = false


	let estados = [ 'ABIERTO','PENDIENTE','CANCELADO','CERRADO','FINALIZADO' ]

	let cart = []
	let nuevo_estado = ''
	let refresh = false

	let accion = ''
	let verFotos = true

	let isFake = false
	let email=''
	$: getCart = async () =>{
		ready=false
		loading = true
		let query =''
		query = `select * from invoicesh where id=${cartid} and ${refresh}=${refresh}`
		const data = await execQuery({query})
		loading= false
		let ds = data.data[0][0] || []
		let detalle = await(getCartDetail())
		ds.detalle=detalle
		cart = ds
		isFakeUser()
		nuevo_estado = ds.estado+''
		return true
	}

	function isFakeUser(){
		if(cart.usuario.trim().substr(0,8)==="__fake__"){
			email = ''
			isFake = true
		}else{
			email = cart.usuario.trim()
		}
		return
	}

	let formapago = [
		{ valor:'', label:'NO DEFINIDO',reca:0,desc:0,msg:''} ,
		{ valor:'AC',label:'EFECTIVO',reca:0,desc:0.15,msg:'Pago ContraEntrega, retirando por nuestro Showroom.'},
		{ valor:'DE',label:'DEPOSITO',reca:0,desc:0.15,msg:'Te estaremos contactando para pasarte los datos de nuestra cuenta.'},
		{ valor:'TR',label:'TRANSFERENCIA',reca:0,desc:0.15,msg:'Te estaremos contactando para pasarte los datos de nuestra cuenta.'},
		{ valor:'MP',label:'MERCADO PAGO',reca:0,desc:0,msg:'Abonas tu compra a traves de Mercado Pago!' }
	]

	async function getCartDetail(){
		loading = true
		let query =''
		query = `select * from invoicesd where idinvoiceh=${cartid} order by id desc`
		const data = await execQuery({query})
		loading= false
		let ds = data.data[0] || []

		return ds
	}

	function volver(){
		cart_handler({cartid:0, goto:'cartlist'})
	}

	function alCatalogo(){
		openMsg1=false
		openMsg2=false


		cart_handler({goto:'catalogo'})

		expand = 'd'
	}

	$: costo_envio = () => {
		let imp = 0
		if(provincias.length && cart.envio_si && cart.tipo==='MINO'){
			imp = provincias.filter( v => v.nombre === cart.provincia )[0].precioDom1
		}
		return imp.toFixed(2)
	}

	$: subtotal = () => {
		let imp = 0
		if(cart.detalle?.length){
			imp = cart.detalle.filter(v => v.borrado===0).reduce( (a,b) => a+(cart.tipo==='MINO' ? b.subtotal1 : b.subtotal0) ,0)
		}
		return imp.toFixed(2)
	}

	$: descuento = () => {
		let desc = 0
		if (cart.tipo==="MINO") {
			desc = subtotal()*(formapago.filter( v => v.valor === cart.metodopago)[0]["desc"])
		}
		return desc.toFixed(2)
	}


	$: recargo = () => {
		let reca = 0
		if (cart.tipo==="MINO") {
			reca = subtotal()*(formapago.filter( v => v.valor === cart.metodopago)[0]["reca"])
		}
		return reca.toFixed(2)
	}

	$: total_a_pagar = (parseFloat(subtotal())+parseFloat(costo_envio())+parseFloat(recargo())-parseFloat(descuento())).toFixed(2)

	let estados_posibles = [
		{inicial:'ABIERTO',posibles:['ABIERTO','PENDIENTE','CANCELADO']},
		{inicial:'PENDIENTE',posibles:['PENDIENTE','CANCELADO']},
		{inicial:'CANCELADO',posibles:['CANCELADO']},
		{inicial:'CERRADO',posibles:['CERRADO','PENDIENTE','CANCELADO','FINALIZADO']},
		{inicial:'FINALIZADO',posibles:['FINALIZADO']}
	]


	async function borrarItem(id){
		if(cart.estado!=='ABIERTO' && cart.estado!=='PENDIENTE'){
			alert(`No se pueden eliminar articulos, su carrito esta ${cart.estado}`)
			return
		}
		if (confirm("Eliminar articulo")){
			loading = true
			let data = {
				tabname: 'invoicesd',
				mutation: 'delete',
				mutationId: 'id',
				params: { id:id }
			}
			const res = await execMutation(data)
			loading = false
			if(res && res.success==="OK"){
				refresh = !refresh
			}else{
				alert("ERROR, no se realizo actualizacion!!!")
			}
		}
		return
	}

	function isValidEmail(em){
		em = (em||'').trim()
		var mailformat =  /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g
		return em.match(mailformat)
	}


	let openLinkMP = false
	let mp_data = ''


	async function save_cart(){
		if(!isValidEmail(email)){
			alert("email no valido")
			return
		}
		if($usuario.email.substr(0,8)==='__fake__'){
			localStorage.removeItem('UPM_USER')
			let usr = {"email":email,"tipo":"MINO","activo":1,"nosale":1}
 			usuario.set(usr)
 			localStorage.setItem('UPM_USER',JSON.stringify({user:usr}))
		}

		if (isFake) {
			cart.usuario = email
		}
		if(cart.estado==='ABIERTO' && nuevo_estado === 'PENDIENTE' ){
			//ADMIN
			await mover_stock(1) //descuenta de stock
			cart.estado='PENDIENTE'
		}else if(cart.estado==='ABIERTO' && nuevo_estado === 'CANCELADO' ){
			//ADMIN
			cart.estado='CANCELADO'
		//}else	if((cart.estado==='ABIERTO'||(cart.estado==='PENDIENTE')) && cart.metodopago !== ''){
		//07ABR2022, cierra aunque no defina la forma de pago.
		}else	if(cart.estado==='ABIERTO'||cart.estado==='PENDIENTE'){
			//auto
			let afectado = await mover_stock(1) // descuenta de stock
			if(afectado) {
				cart.estado='CERRADO'

				// Paga a traves de mercado pago
				if(cart.metodopago === 'MP' && cart.mpstatus!=='X'){
					let mp_payment_data = {
						id : cart.id,
					    payer_email : cart.usuario,
						unit_price : total_a_pagar || 0 ,
					    payer_name : cart.nombre || '',
					    payer_surname : cart.apellido || '',
					}
					mp_data = await execMercadoPago(mp_payment_data) || {mpid : ''}
					cart.mpstatus ='X'
					cart.mpid = JSON.stringify(mp_data)
					openLinkMP = true
				}
			}
		}else	if(cart.estado==='PENDIENTE' && nuevo_estado === 'CANCELADO'){
			//ADMIN
			await mover_stock(0) //devuelve stock
			cart.estado='CANCELADO'
		}else if(cart.estado==='PENDIENTE'){
			//auto
			//lo cierro aunque no defina la forma de pago
			//}else if(cart.estado==='PENDIENTE' && cart.metodopago !== ''){
			cart.estado='CERRADO'
		}else if(cart.estado==='CERRADO' && nuevo_estado==='PENDIENTE'){
			//ADMIN
			// reset forma de pago
			cart.metodopago =''
			cart.mpid = ''
			cart.mpstatus = ''
			cart.estado='PENDIENTE'
		}else	if(cart.estado==='CERRADO' && nuevo_estado==='FINALIZADO'){
			//ADMIN
			cart.estado='FINALIZADO'
		}else if(cart.estado==='CERRADO' && nuevo_estado==='CANCELADO'){
			//ADMIN
			await mover_stock(0) //devuelve stock
			cart.estado='CANCELADO'

		}
		save()
	}

	async function save(){
		// Cabecera de comprobantes
 		loading = true
 		delete cart.detalle
 		//console.log(cart)
 		let data = {
 			tabname: 'invoicesh',
 			mutation: 'update',
 			mutationId: 'id',
 			params: cart
 		}
 		const res = await execMutation(data)
 		loading = false
 		if(res && res.success==="OK"){

 			if (!openLinkMP) {
	 			if(cart.estado==='CERRADO') {
	 				openMsg1=true
	 			}else {
	 				openMsg2=true
	 			}
 				refresh = !refresh
	 		}else{
 				refresh = !refresh
	 		}
			expand='d'

 		}else{
 			alert("ERROR, no se realizo actualizacion!!!")
 		}
 	}

 	async function mover_stock(marca){
 		loading = true
		let stmt = `update invoicesd d set d.borrado=1 where d.idinvoiceh=${cart.id} and d.borrado=0 and marca=0
				and d.cantidad > (select (qtty-qttysold) from stock where idproducto=d.idproducto and subproducto=d.subproducto and size=d.size)`
		const res = await execRawMutation(stmt)
		//loading = false
		// if(res && res.success==="OK"){
		// 	loading = true
		// 	stmt = `update invoicesd set marca=${marca} where idinvoiceh=${cart.id} and borrado=0`
		// 	const res2 = await execRawMutation(stmt)
		// 	loading = false
		// 	if(res2 && res2.success==="OK"){
		// 		return true
		// 	}else{
		// 		alert("ERROR, no se realizo actualizacion!!!")
		// 	}
		// }


			stmt = `update invoicesd set marca=${marca} where idinvoiceh=${cart.id} and borrado=0`
			const res2 = await execRawMutation(stmt)
			loading = false
			if(res2 && res2.success==="OK"){
				return true
			}else{
				alert("ERROR, no se realizo actualizacion!!!")
			}

		return false
 	}


 	function imprimir(){
 		window.print()
 	}

	function imprimir2() {
      var divContents = document.getElementById("areaImprimible").innerHTML;
      var a = window.open('', '', 'height=500, width=500');
      a.document.write(`<html><head>
				<link rel="stylesheet" href="mini.css">
			  <link rel='stylesheet' href='/build/bundle.css'>
			  <link rel="stylesheet" href="upm.css">
      </head>`);

      a.document.write('<body >');
      a.document.write(divContents);
      a.document.write('</body></html>');
      a.document.close();
			setTimeout( ()=>a.print(), 2000)
  }


	onMount( async () => {
		loading = true
		let query = `select * from provincias order by id`
		const data = await execQuery({query})
		loading= false
		provincias = data.data[0] || {}
	})

</script>


<!-- header -->
{#await getCart()}
	<div class="spinner"></div>
{:then ready}

	<div class="container" id="areaImprimible">
		<div class="row no-print" style="border-bottom:solid 1px gray;padding:2px;margin:3px;">

			<div class="col-sm-11">
				<span style="padding:1px 12px;color:red;" on:click={volver}><strong>◄ Volver</strong></span>
				<span style="padding:1px 12px;border-bottom:{expand==='d'?'solid 3px black':''};" on:click={()=>expand = expand==='d'?'':'d'}>Detalle</span>
				<span style="padding:1px 12px;border-bottom:{expand==='h'?'solid 3px black':''};" on:click={()=>expand = expand==='h'?'':'h'}>Info</span>
			</div>
			<div class="col-sm-1 text-right">
				<span on:click={()=>refresh = !refresh}>Refrescar</span>
			</div>
		</div>

		{#if expand==='h'}


			<div class="row">
				<div class="col-sm-6 lbl">&nbsp;#{cart.id}</div>
				<div class="col-sm-6 lbl text-right">{cart.created_at.substr(0,10)} {cart.created_at.substr(11,8)}</div>

			  <div class="col-sm-12">
			  	<input bind:value={email} class="w-full small" placeholder="Ingresar Email">
			  </div>

			  <div class="col-sm-6 lbl">Nombre</div>
			  <div class="col-sm-6 lbl">Apellido</div>
			  <div class="col-sm-6">
			  	<input bind:value={cart.nombre} class="w-full small">
			  </div>
			  <div class="col-sm-6">
			  	<input bind:value={cart.apellido} class="w-full small">
			  </div>

			  <div class="col-sm-12 lbl">Cuit/Dni</div>
			  <div class="col-sm-12">
			  	<input bind:value={cart.cuit} class="small">
			  </div>

			  <div class="col-sm-12 lbl">Domicilio</div>
			  <div class="col-sm-12">
			  	<input bind:value={cart.domicilio} class="small">
			  </div>

			  <div class="col-sm-6 lbl">Ciudad</div>
			  <div class="col-sm-4 lbl">Prov</div>
			  <div class="col-sm-2 lbl">CP</div>
			  <div class="col-sm-6">
			  	<input bind:value={cart.ciudad} class="small">
			  </div>
			  <div class="col-sm-4">
			  	<select bind:value={cart.provincia} class="small">
			  		{#each provincias as item, index}
			  			<option value="{item.nombre}">{item.nombre}</option>
			  		{/each}
			  	</select>
			  </div>

			  <div class="col-sm-2">
			  	<input bind:value={cart.codpostal} class="small">
			  </div>

			  <div class="col-sm-5 lbl">Telefono</div>
			  <div class="col-sm-7 lbl">Incluir Envio</div>
			  <div class="col-sm-5">
			  	<input bind:value={cart.telefono} class="small">
			  </div>
			  <div class="col-sm-3 v-center">
			  	<input type=checkbox bind:checked={cart.envio_si}> $ {costo_envio()}
			  </div>


			  <div class="col-sm-6 lbl">Forma pago</div>
			  <div class="col-sm-3 lbl">Estado</div>
			  <div class="col-sm-3 lbl">Tipo Compra</div>
			  <div class="col-sm-6">
			  	<select bind:value={cart.metodopago} class="small">
				  	{#each formapago as item, index}
							<option value="{item.valor}" disabled={cart.tipo!=='MINO' && item.valor==='MP'}>{item.label}</option>
				  	{/each}
			  	</select>
			  </div>
			  <div class="col-sm-3">
			  	<select bind:value={nuevo_estado} class="small" disabled="{$usuario.tipo!=='ADMIN'}">
			  		{#each estados_posibles.filter( v => v.inicial===cart.estado)[0].posibles as estado, index}
			  			<option value="{estado}">{estado}</option>
			  		{/each}
			  	</select>

			  </div>
			  <div class="col-sm-3">
			  	<select bind:value={cart.tipo} class="small" disabled="{$usuario.tipo!=='ADMIN'}">
			  		<option value="MINO">MINO</option>
			  		<option value="MAYO">MAYO</option>
			  	</select>
			  </div>
			  <div class="col-sm-6" style="padding:2px 6px;color:tomato;">
			  	<span style="display:{cart.tipo==='MINO'&&cart.metodopago==='TR'?'':'none'};">Tenes 20% de descuento! </span>
			  	{formapago.filter( v => v.valor === cart.metodopago)[0]["msg"]}
			  </div>
			  <div class="col-sm-3 lbl"></div>
			  <div class="col-sm-3 lbl"></div>

		  </div>

		  <div class="row pt-1">
			  <div class="col-sm-4 text-right">Total de su canasta</div>
			  <div class="col-sm text-right">{subtotal()} $</div>
			  <div class="col-sm-1">&nbsp;</div>
			</div>
			<div class="row pt-1">
			  <div class="col-sm-4 text-right">Envio</div>
			  <div class="col-sm text-right">{costo_envio()} $</div>
			  <div class="col-sm-1">&nbsp;</div>
			</div>

			{#if recargo()>0}
				<div class="row pt-1">
				  <div class="col-sm-4 text-right">Otros (Recargos)</div>
				  <div class="col-sm text-right">{recargo()} $</div>
				  <div class="col-sm-1">&nbsp;</div>
				</div>
			{/if}


			{#if descuento()>0}
				<div class="row pt-1">
				  <div class="col-sm-4 text-right">Otros (Descuento)</div>
				  <div class="col-sm text-right">- {descuento()} $</div>
				  <div class="col-sm-1">&nbsp;</div>
				</div>
			{/if}

			<div class="row pt-1">
			  <div class="col-sm-4 text-right">Total a PAGAR</div>
			  <div class="col-sm text-right">{total_a_pagar} $</div>
			  <div class="col-sm-1">&nbsp;</div>
		  </div>

		  <div class="row" style="margin-bottom: 50px;">
		  	<div class="col-sm-12 text-right">
		  		<button class="secondary" on:click={save_cart}
		  			disabled="{!($usuario.tipo==='ADMIN'||cart.estado==='ABIERTO'||cart.estado==='PENDIENTE')}">
		  			✔ Aceptar
		  		</button>
		  	</div>
		  	<div class="col-sm-6">
		  		Por favor, completa los datos por si necesitamos contactarte.
		  	</div>

		  </div>
	  		<span style="position:fixed;bottom:0;left:0;font-size: 1.1em;background-color:orange;padding:4px 10px;">
	  			Plazo de acreditacion del pago 24hs, pasado ese tiempo los productos no se mantendran en reserva.
	  		</span>
	  {/if}


		<!-- detalles -->

	  {#if expand==='d'}

	  	<div class="container">
	  		<br>

	  		<!-- cabecera se imprime -->
	  		<div class="row no-screen header-compra">

				<div class="col-sm-6 lbl">&nbsp;#{cart.id}</div>
				<div class="col-sm-6 lbl text-right">{cart.created_at.substr(0,10)} {cart.created_at.substr(11,8)}</div>

				<div class="col-sm-3">Email</div>
				<div class="col-sm-9">{email}</div>

				<div class="col-sm-3 lbl">Cliente</div>
				<div class="col-sm-9">{cart.nombre} {cart.apellido}</div>

				<div class="col-sm-3 lbl">Cuit/Dni</div>
				<div class="col-sm-9">{cart.cuit}</div>

				<div class="col-sm-3 lbl">Domicilio</div>
				<div class="col-sm-9">{cart.domicilio}</div>
				<div class="col-sm-3 lbl">&nbsp;</div>
				<div class="col-sm-3">&nbsp;{cart.ciudad}&nbsp;-</div>
				<div class="col-sm-3">&nbsp;{cart.provincia}&nbsp;-</div>
				<div class="col-sm-3">&nbsp;{cart.codpostal}&nbsp;-</div>


				<div class="col-sm-3 lbl">Telefono</div>
				<div class="col-sm-3">{cart.telefono}</div>
				<div class="col-sm-1 lbl">Incluir Envio</div>
				<div class="col-sm-5 v-center"><input type=checkbox bind:checked={cart.envio_si}> $ {costo_envio()}</div>

				<div class="col-sm-1 lbl">Forma pago</div>
				<div class="col-sm-3">{cart.metodopago}</div>
				<div class="col-sm-1 lbl">Estado</div>
				<div class="col-sm-3">{cart.estado}</div>
				<div class="col-sm-1 lbl">Tipo Compra</div>
				<div class="col-sm-3">{cart.tipo}</div>
	  		</div>
	  		<br>

	  		<div class="row no-print">
		  		<div class="col-sm-12 v-center"><input type="checkbox" bind:checked={verFotos}>Imagenes</div>
		  	</div>
	  		<div class="row" style="font-size:0.9em;font-weight:bold;">
	  			<div class="col-sm-1">Id Prod</div>
	  			<div class="col-sm-3">Producto</div>
	  			<div class="col-sm-3">Modelo/Talle</div>
	  			<div class="col-sm-2 text-right">Cant/Precio</div>
	  			<div class="col-sm-2 text-right">Importe</div>
	  			<div class="col-sm-1">&nbsp;</div>
	  		</div>
		  	{#each cart.detalle as item, index}
		  		<div class="row border" style="padding:4px 2px;margin-bottom:2px;">
				    {#if !verFotos}
				    	<div class="col-sm-1 {item.borrado===1?'borrado':''}" on:click={()=>alert("aca ir a ver las fotos")}>{item.idproducto}</div>
				    {:else}
				    	<div class="col-sm-1 no-screen">{item.idproducto}</div>
				    	<div class="col-sm-1 no-print"><img src="upload/{item.imagenes.split(',')[0]}" height="20px" alt=""></div>
				    {/if}



				    <div class="col-sm-3 {item.borrado===1?'borrado':''}">{item.producto}</div>
				    <div class="col-sm-3 {item.borrado===1?'borrado':''}">{item.subproducto} - {item.size}</div>
				    {#if cart.tipo==='MINO'}
				    	<div class="col-sm-2 text-right {item.borrado===1?'borrado':''}">{item.cantidad} x {item.importe1.toFixed(2)}</div>
				    	<div class="col-sm-2 text-right {item.borrado===1?'borrado':''}">{item.subtotal1.toFixed(2)}</div>
				    {:else}
				      	<div class="col-sm-2 text-right {item.borrado===1?'borrado':''}">{item.cantidad} x {item.importe0.toFixed(2)}</div>
					    <div class="col-sm-2 text-right {item.borrado===1?'borrado':''}">{item.subtotal0.toFixed(2)}</div>
					{/if}
					  <div class="col-sm-1 text-right" style="color:red;font-weight:bold;">
						  <span on:click={()=>borrarItem(item.id)}>&Cross;</span>
						  <!--  ({item.marca}) ({item.borrado}) -->
						</div>
					{#if item.borrado===1}
		  				<div class="col-sm-12" style="color:#666;">
		  					<em>SIN STOCK de este articulo. Al momento de finalizar tu compra este articulo ya no esta disponible.</em>
		  				</div>
		  			{/if}
				  </div>
		  	{/each}
		  		<div class="row">
		  			<div class="col-sm-8 text-right">Subtotal</div>
		  			<div class="col-sm-3 text-right">{subtotal()}</div>
		  			<div class="col-sm-1">&nbsp;</div>
		  			<div class="col-sm-8 text-right">Envio</div>
		  			<div class="col-sm-3 text-right">{costo_envio()}</div>
		  			<div class="col-sm-1">&nbsp;</div>

					{#if recargo()>0}
					  <div class="col-sm-8 text-right">Otros (Recargos)</div>
					  <div class="col-sm-3 text-right">{recargo()} $</div>
					  <div class="col-sm-1">&nbsp;</div>
					{/if}


					{#if descuento()>0}
					  <div class="col-sm-8 text-right">Otros (Descuento)</div>
					  <div class="col-sm-3 text-right">- {descuento()} $</div>
					  <div class="col-sm-1">&nbsp;</div>
					{/if}
		  		</div>
		  		<div class="row" style="font-weight:bold;">
		  			<div class="col-sm-8 text-right">TOTAL</div>
		  			<div class="col-sm-3 text-right">{total_a_pagar}</div>
		  			<div class="col-sm-1">&nbsp;</div>
		  		</div>

			  	<div class="row no-print">
		  			{#if (cart.estado==='ABIERTO' || cart.estado=== 'PENDIENTE')}
			  			<div class="col-sm-12">&nbsp;</div>
			  			<div class="col-sm-6 text-right">
			  				<button class="inverse" on:click={()=>expand='h'}>Finalizar Compra</button>
			  			</div>
			  			<div class="col-sm-6" xstyle="text-align:center;">
			  				<button class="secondary" on:click={alCatalogo}>Continuar Compra</button>
			  			</div>
				  	{:else}
				  		<div class="col-sm-12">&nbsp;</div>
			  			<div class="col-sm-6 text-right">
			  				<button on:click={imprimir}>Imprimir</button>
								<button on:click={imprimir2}>Imprimir2</button>
			  			</div>
			  		{/if}
			  	</div>
		  		<div class="row">
			  		<div class="col-sm-12 text-right">
			  			<h4>{cart.estado}</h4>
			  		</div>
			  	</div>

		  </div>
	  {/if}


	</div>
{/await}


{#if openLinkMP}
	<div class="modal">
		<div class="container v-center" style="background-color:white;margin:10px 10px;padding:10px;min-height:200px;max-height:500px;height:300px;border-radius:5px;max-width:300px;">
			<div class="row border">
				<div class="col-sm-12 text-center" style="padding:5px 15px;">
					<h5>Presiona <em>Pagar</em> para ver las opciones de pago que te ofrece Mercado Pago&reg;.</h5>
				</div>
				<div class="col-sm-12 text-right">
					<strong>
					<form method="POST" style="background-color:white;border:none;" on:submit={()=>openLinkMP=false}>
				        <script
				        src="https://www.mercadopago.com.ar/integrations/v1/web-payment-checkout.js"
				        data-preference-id="{mp_data.mpid}">
				        </script>
				    </form>
				    </strong>
				</div>
			</div>
		</div>
	</div>
{/if}


{#if openMsg1}
	<div class="modal">
		<div class="container v-center" style="background-color:white;margin:10px 10px;padding:10px;min-height:200px;max-height:500px;dheight:300px;border-radius:5px;max-width:300px;">
			<div class="row border">
				<div class="col-sm-12 text-center" style="padding:5px 15px;">
					<h4>Gracias por confiar en&nbsp;
						<span style="font-size:1.2em;font-family:Sacramento;font-weight: bold;">
							Un poco m&aacute;s.<span style="color:red;">&hearts;
						</span>
					</h4>
					<p>Hemos recepcionado tu compra</p>
					<p>En breve nos contactaremos por whatApp para enviarte los datos para el pago y coordinar entrega o envio.</p>
					<p>Para consultas envianos whatsApp a +54 9 11 3050-3438. Nuestro horario de atencion es de Lu a Sa de 11 a 19hs</p>
					<p></p>
					<p>El id de tu compra es : <strong>0001-{('00011700'+cart.id).substr(-8)}</strong></p>
				</div>
				<div class="col-sm-12 text-center">
					<button tabindex="-1" on:click={alCatalogo}>Salir</button>
				</div>
				<div class="col-sm-11 text-right" style="font-size:1.2em;font-family:Sacramento;font-weight: bold;">
					Un poco m&aacute;s.<span style="color:red;">&hearts;</span>
				</div>
			</div>
		</div>
	</div>
{/if}



{#if openMsg2}
	<div class="modal">
		<div class="container v-center" style="background-color:white;margin:10px 10px;padding:10px;min-height:200px;max-height:500px;height:300px;border-radius:5px;max-width:300px;">
			<div class="row border">
				<div class="col-sm-12 text-center" style="padding:5px 15px;">
					<h4>Falta que definas tu forma de pago</h4>
					<p>Clickea en tu carrito para poder definirla.</p>
					<p>Para consultas envianos whatsApp a +54 9 11 3050-3438. Nuestro horario de atencion es de Lu a Sa de 11 a 19hs</p>
					<p></p>
					<p>El id de tu compra es : <strong>0001-{('00011700'+cart.id).substr(-8)}</strong></p>
				</div>
				<div class="col-sm-12 text-center">
					<button tabindex="-1" on:click={alCatalogo}>Salir</button>
				</div>
				<div class="col-sm-11 text-right" style="font-size:1.2em;font-family:Sacramento;font-weight: bold;">
					Un poco m&aacute;s.<span style="color:red;">&hearts;</span>
				</div>
			</div>
		</div>
	</div>
{/if}


<style>
	.small{
	    width:98%;
	    padding:2px 8px;
	}
	.lbl{
		font-size:0.8em;
		color:#555;
		margin-bottom:-5px;
	}
	.borrado{
		color:red;
		text-decoration: line-through;
	}
	.header-compra > div{
		margin: 4px 0px;
	}
</style>
